import type { NDateLocale } from './enUS'
import { et } from 'date-fns/locale'

const dateEtEE: NDateLocale = {
  name: 'et-EE',
  locale: et
}

export default dateEtEE
